import { createContext } from 'react';

export type ToastVariant = 'success' | 'error' | 'info';

export interface ToastOptions {
  title?: string;
  description?: string;
  variant?: ToastVariant;
  // Milliseconds before the toast auto-dismisses. Set to 0 to keep it
  // visible until the user dismisses it manually.
  durationMs?: number;
}

export interface ToastEntry extends Required<Pick<ToastOptions, 'variant'>> {
  id: number;
  title?: string;
  description?: string;
  durationMs: number;
}

export interface ToastContextValue {
  showToast: (options: ToastOptions) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);
